module.exports = __webpack_public_path__ + "static/media/2_en.6cf6049a.png";